import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { countryToIso } from '@sola/schema/dotcom/shared/geo.ts';
import { key } from '../../organisms-cms/child-bio/utils/bioKeys.tsx';
import { getFamilyList } from '../../organisms-cms/child-bio/utils/familyList.tsx';
import { listFormat } from '../../organisms-cms/child-bio/utils/simpleList.tsx';
import { getAge } from '../../utils/child-bio.ts';
type ChildBioSummaryBaseProps = {
  details: ChildDetails;
  className?: string;
};
type ChildBioSummaryShortProps = ChildBioSummaryBaseProps & {
  short: true;
};
type ChildBioSummaryLongProps = ChildBioSummaryBaseProps & {
  short?: false | undefined;
};
export type ChildBioSummaryProps = ChildBioSummaryShortProps | ChildBioSummaryLongProps;
export const ChildBioSummary = t0 => {
  const $ = _c(22);
  const {
    className: t1,
    details,
    short: t2
  } = t0;
  const className = t1 === undefined ? "mb-comfy-sm" : t1;
  const short = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["bio"];
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const {
    t
  } = useTranslation(t3);
  const {
    ageInYearsAndMonths,
    correspondenceLanguage,
    country,
    localId
  } = details;
  let t4;
  let t5;
  if ($[1] !== ageInYearsAndMonths || $[2] !== className || $[3] !== correspondenceLanguage || $[4] !== country || $[5] !== details.gender || $[6] !== details.hangul.preferred || $[7] !== details.householdList[0].householdMemberList || $[8] !== details.interests.favoriteProjectActivity || $[9] !== details.interests.thingsILike || $[10] !== details.name.preferred || $[11] !== localId || $[12] !== short || $[13] !== t) {
    const age = getAge(ageInYearsAndMonths);
    let t6;
    if ($[16] !== country || $[17] !== localId) {
      t6 = countryToIso(country, localId);
      $[16] = country;
      $[17] = localId;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    const countryIso = t6;
    const countryKey = `geo:countries.${countryIso}.nameS`;
    const translatedCountry = t(countryKey);
    const languageKey = key("bio:language", correspondenceLanguage);
    const translatedLanguage = t(languageKey as unknown as TemplateStringsArray);
    const favoriteActivities = details.interests.thingsILike.length > 0 ? t("bio:favoriteActivities", {
      context: details.gender,
      favorites: listFormat(short ? details.interests.thingsILike.slice(0, 3) : details.interests.thingsILike)
    }) : "";
    const projectActivities = details.interests.favoriteProjectActivity.length > 0 ? t("bio:projectActivities", {
      context: details.gender,
      activities: listFormat(details.interests.favoriteProjectActivity)
    }) : "";
    t4 = className;
    t5 = t(short ? "bio:summaryShort" : "bio:summary", {
      context: details.gender,
      childName: details.name.preferred,
      koreanName: details.hangul.preferred || details.name.preferred,
      age,
      country: translatedCountry,
      family: getFamilyList(details.householdList[0].householdMemberList),
      favoriteActivities,
      projectActivities,
      ...(short ? {} : {
        language: translatedLanguage
      }),
      interpolation: {
        escapeValue: false
      }
    });
    $[1] = ageInYearsAndMonths;
    $[2] = className;
    $[3] = correspondenceLanguage;
    $[4] = country;
    $[5] = details.gender;
    $[6] = details.hangul.preferred;
    $[7] = details.householdList[0].householdMemberList;
    $[8] = details.interests.favoriteProjectActivity;
    $[9] = details.interests.thingsILike;
    $[10] = details.name.preferred;
    $[11] = localId;
    $[12] = short;
    $[13] = t;
    $[14] = t4;
    $[15] = t5;
  } else {
    t4 = $[14];
    t5 = $[15];
  }
  let t6;
  if ($[19] !== t4 || $[20] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
};